import { styled } from '@mui/material/styles';
import { Checkbox as BaseCheckbox } from 'components/inputs';
import Link from 'components/Link';

export const ActionItem = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  '.MuiFormControlLabel-root': {
    marginLeft: 0,
    marginRight: 0
  }
}));

export const Checkbox = styled(BaseCheckbox)(({ theme }) => ({
  '& + .MuiTypography-body1': {
    fontWeight: theme.fontWeight.bold,
    fontSize: theme.fontSize.xsmall,
    textTransform: 'uppercase'
  }
}));

export const DownloadLink = styled(Link)(({ theme }) => ({
  fontSize: theme.fontSize.xsmall
}));

export const DownloadText = styled('span')(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  marginLeft: theme.spacing(1),
  textTransform: 'uppercase'
}));

export const NDAFooter = styled('div')(({ theme, wrap, justify }) => ({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  flexWrap: wrap || 'wrap',
  marginBottom: theme.spacing(-1.25),
  ...(justify && {
    justifyContent: justify
  }),
  '@media (max-width: 650px)': {
    justifyContent: 'center'
  }
}));

export const NDAViewer = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`,
  minHeight: '370px'
}));

export const NDAContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  [`& ${NDAFooter}`]: {
    flexGrow: 0
  },
  [`& ${NDAViewer}`]: {
    flexGrow: 1
  }
}));

export const NDAText = styled('div')(({ theme }) => ({
  fontWeight: theme.fontWeight.light,
  whiteSpace: 'pre-wrap'
}));

export const Title = styled('h3')(({ theme }) => ({
  fontSize: theme.fontSize.large,
  fontWeight: theme.fontWeight.light,
  margin: 0
}));
